module.exports = __webpack_public_path__ + "images/2a7ec450c1a7437e6fd46105a8858ef8.png";